/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 11:01:05 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React, { FormEvent } from "react";

// A cool utility component that we created to intercept the bubbled up submit event for a form
// and stop the propagation here so the event does not bubble up to the parent form.
// This should be used in the case where you have nested form components within a DOM tree and
// you dont want parent forms to have the listen to the submit event on the bubbling phase.
// Note: You can also use it if you have other elements other than forms that are listening to
// the submit event.
// The form component(s) that need to listen to the event should be children of this component

interface FormSubmitBubblingStopperProps {
  children: React.ReactNode;
}

export const FormSubmitBubblingStopper = (props: FormSubmitBubblingStopperProps) => {
  const stopSubmitEventBubble = (event: FormEvent) => event.stopPropagation();

  return <div onSubmit={stopSubmitEventBubble}>{props.children}</div>;
};
